export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/nathalie-profile-68a8aeaf2f08e8985f6a05b9b0e59839.png";